import { SCHEDULE_REPORTS_STATUSES } from 'appconstants';

export default value => {
  if (value === 'ACTIVE') {
    return SCHEDULE_REPORTS_STATUSES.ACTIVE;
  } if (value === 'ERROR') {
    return SCHEDULE_REPORTS_STATUSES.ERROR;
  } return SCHEDULE_REPORTS_STATUSES.PROCESSING;
};
